import { BreakpointArray, Orientation } from '@thg-commerce/gravity-theme'
import { TextStyling } from '@thg-commerce/gravity-theme/typography/typography'

import { createPageLayoutTheme } from '../pageLayout'
import { PageLayout, Component } from '../Renderer/layout'

export enum ProductSummaryPriceDisplayStyle {
  CHEAPEST = 'cheapest',
  RANGE = 'range',
}

export enum ProductImageGalleryStyle {
  CAROUSEL = 'carousel',
  GRID = 'grid',
}

interface ImageGallery extends Component<'imageGallery'> {
  style: BreakpointArray<ProductImageGalleryStyle>
  grid?: {
    // Indicates if the `style` contains a grid style at any breakpoint
    enabled: boolean
    gapSpacing: number
  }
  carousel: {
    // Indicates if the `style` contains a carousel style at any breakpoint
    enabled: boolean
  }
}
interface ProductSummary extends Component<'productSummary'> {
  price: {
    displayStyle: ProductSummaryPriceDisplayStyle
    displayRRPText: boolean
    orientation: Orientation
    price: {
      textStyle: TextStyling
    }
    rrp: {
      textStyle: TextStyling
    }
    savings: {
      textStyle: TextStyling
    }
    priceWithRRP: {
      textStyle: TextStyling
    }
  }
  title?: {
    textStyle: TextStyling
  }
}
interface ShoeSizeMe extends Component<'shoeSizeMe'> {}
interface SizeGuide extends Component<'sizeGuide'> {}
interface ProductOptions extends Component<'productOptions'> {
  addToBasketButton: {
    addToWishlistButton: {
      show: boolean
    }
  }
  addToWishlistButton: {
    show: boolean
  }
}
interface FreeDeliveryIndicator extends Component<'freeDeliveryIndicator'> {}
interface BuyNowPayLater extends Component<'buyNowPayLater'> {}
interface ProductAvailability extends Component<'productAvailability'> {}
interface OutOfStockNotification extends Component<'outOfStockNotification'> {}
interface MarketedSpecialOffer extends Component<'marketedSpecialOffer'> {}
interface PromotionalMessage extends Component<'promotionalMessage'> {}
interface DeliveryAndReturnsInfo extends Component<'deliveryAndReturnsInfo'> {}
interface LiveChat extends Component<'liveChat'> {}
interface ProductDescription extends Component<'productDescription'> {}
interface FrequentlyBoughtTogether
  extends Component<'frequentlyBoughtTogether'> {}
interface StoryStream extends Component<'storyStream'> {}
interface OtherCustomersBought extends Component<'otherCustomersBought'> {}
interface ProductRecommendations extends Component<'productRecommendations'> {}
interface TopProductReviews extends Component<'topProductReviews'> {}
interface RecentlyViewedProducts extends Component<'recentlyViewedProducts'> {}

export interface ProductPageLayout
  extends PageLayout<
    | ImageGallery
    | ProductSummary
    | ShoeSizeMe
    | SizeGuide
    | ProductOptions
    | FreeDeliveryIndicator
    | BuyNowPayLater
    | ProductAvailability
    | OutOfStockNotification
    | MarketedSpecialOffer
    | PromotionalMessage
    | DeliveryAndReturnsInfo
    | LiveChat
    | ProductDescription
    | FrequentlyBoughtTogether
    | StoryStream
    | OtherCustomersBought
    | ProductRecommendations
    | TopProductReviews
    | RecentlyViewedProducts
  > {}

const { styled, useTheme } = createPageLayoutTheme<ProductPageLayout>()

export { styled, useTheme }
